<template lang="pug">
div
  a.Toggle(
    href='#',
    v-for='(option, optI) in model.options',
    v-if='!disabledOptions.includes(option.id)'
    @click.prevent='selectOption(option, optI)',
    :class=`{
      'Toggle--selected': currentOptionIndex === optI,
      'Toggle--disabled': disabledOptions.includes(option.id)
    }`,
  )
    .ToggleName {{ option.name | ratio }}

  p.f6.lh-copy.measure.gray(
    v-if='selectedOption.description && !areAllOptionsDisabled && !isCurrentOptionDisabled'
  )
    | #[strong {{ selectedOption.name | ratio }}]:&nbsp;
    span(v-html='selectedOption.description')

  div(v-if='selectedOption.customField')
    input(v-model.lazy='selectedOption.customFieldData' :placeholder='selectedOption.description')

  p.f6.lh-copy.measure.ToggleError.dark-red(
    v-if='!areAllOptionsDisabled && isCurrentOptionDisabled'
  ) Please select an available option

  p.f6.lh-copy.measure.ToggleError.dark-red(
    v-if='isCustomFieldEmpty'
  ) Please enter a description
</template>

<script>

import numeral from 'numeral'

export default {
  name: 'bookart-toggle',
  props: ['value', 'selectedOptionIndex'],
  data () {
    return {
      currentOptionIndex: this.selectedOptionIndex
    }
  },
  watch: {
    currentOptionIndex (optionI) {
      this.$parent.$emit('select', optionI)
    }
  },
  computed: {
    selectedOption () {
      return this.model.options[this.currentOptionIndex]
    },
    disabledOptions () {
      return this.$parent.$parent.disabledOptions
    },
    isCurrentOptionDisabled () {
      return this.disabledOptions.includes(this.selectedOption.id)
    },
    areAllOptionsDisabled () {
      return this.model.options
        .every(option => this.disabledOptions.includes(option.id))
    },
    isCustomFieldEmpty() {
      return this.selectedOption.customField && !this.selectedOption.customFieldData
    },
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    selectOption (option, optI) {
      if (!this.disabledOptions.includes(option.id))
        this.currentOptionIndex = optI
    }
  },
  filters: {
    ratio (val) {
      return val.replace(/([0-9]+)x([0-9]+)/gi, '$1×$2')
    },
    price (val) {
      return numeral(val).format('$ 0,0.00')
    }
  }
}
</script>

<style lang="stylus" scoped>

$near-black = #333
$mid-gray = #555
$lavender = #9c84f0
$mid-lavender = #c9c3df

$breakpoints = {
  ns: 'screen and (min-width: 30em)',
  m: 'screen and (min-width: 30em) and (max-width: 60em)',
  l: 'screen and (min-width: 60em)'
}

$button-height = 52px
$shadow-width = 1rem

.ToggleGroup
  margin-left: 1px

  padding-left: $shadow-width
  padding-right: $shadow-width
  padding-bottom: 30px

  white-space: nowrap
  overflow-y: hidden
  overflow-x: scroll
  -webkit-overflow-scrolling: touch

.Toggle
  display: block
  padding: 1rem 2rem

  text-align: center
  text-decoration: none
  text-transform: uppercase

  transition: background-color .2s

  color: $lavender
  border: 1px solid $lavender
  background-color: white

  margin-bottom: 0.5rem

  @media $breakpoints['ns']
    display: inline-block
    margin-right: 0.5rem

    &:hover, &:active
      color: white
      background-color: $mid-lavender

  &.Toggle--selected
    color: white
    background-color: $lavender

  &.Toggle--disabled
    position: relative
    z-index: -1
    cursor: default
    background-color: rgba(0, 0, 0, 0.1)
    color: rgba(0, 0, 0, 0.2)
    border-color: rgb(205, 205, 205)

.ToggleName
  font-weight: 700
  font-size: .8em

  @media $breakpoints['ns']
    font-size: 1em

.TogglePrice
  display: inline-block
  background-color: #f5f5f5
  padding: 4px 7px
  margin-top: .5rem
  color: $near-black
  font-size: 12px

  transition: background-color .2s

  .Toggle--disabled &
    opacity: 0.3

.Toggle.Toggle--selected .TogglePrice
  background-color: lighten($near-black, 30%)
  color: white

.Toggle:hover .TogglePrice
  @media $breakpoints['ns']
    background-color: lighten($near-black, 30%)
    color: white

</style>



// WEBPACK FOOTER //
// BookartToggle.vue?4995fed2